import { render, staticRenderFns } from "./SoftwareComponentLoginEdit.vue?vue&type=template&id=b900867c&scoped=true&"
import script from "./SoftwareComponentLoginEdit.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentLoginEdit.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentLoginEdit.vue?vue&type=style&index=0&id=b900867c&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b900867c",
  null
  
)

export default component.exports